import React from 'react';
import { FALLBACK_CURRENCY } from './invoiceForm';
import { getInvoiceSettings } from './services/invoiceService';

let cached: string | undefined;
let pending: Promise<string> | undefined;

export const rememberTenantCurrency = (code?: string) => {
  if (code?.trim()) cached = code.trim().toUpperCase();
};

export const loadTenantCurrency = (): Promise<string> => {
  if (cached) return Promise.resolve(cached);
  pending ??= getInvoiceSettings()
    .then(settings => {
      rememberTenantCurrency(settings.defaultCurrency);
      return cached ?? FALLBACK_CURRENCY;
    })
    .catch(() => FALLBACK_CURRENCY)
    .finally(() => {
      pending = undefined;
    });
  return pending;
};

/**
 * Every tenant bills in a single operating currency, so prices outside the invoice
 * module (catalog, previews) read it from invoice settings instead of guessing.
 */
export const useTenantCurrency = (): string => {
  const [currency, setCurrency] = React.useState(cached ?? FALLBACK_CURRENCY);

  React.useEffect(() => {
    let active = true;
    void loadTenantCurrency().then(code => {
      if (active) setCurrency(code);
    });
    return () => {
      active = false;
    };
  }, []);

  return currency;
};
